<template>
  <router-view
    :types-with-assets="typesWithAssets"
  />
</template>

<script>
export default {
  props: {
    typesWithAssets: Array,
  },
};
</script>
